<div class="modal-top-bar">
    <h3>Alert #{{alert.id}} features</h3>
</div>
<div class="modal-container afm-list">
    <span>{{alert.features?.length ?? 0}} features found</span>
    <div class="afm-feature" *ngFor="let feat of alert.features">
        {{feat.name}}
    </div>
</div>
<div *ngIf="alert.attacks" class="modal-container afm-list mt-2">
    <span>{{alert.attacks.length}} Attacks found</span>
    <div class="afm-feature" *ngFor="let attack of alert.attacks; let i = index">
        <div *ngIf="i > 0" class="separator"></div>
        <div [ngSwitch]="getStatus(attack)" class="mb-2" [ngClass]="{'mt-3': i > 0}">
            Status:
            <span *ngSwitchCase="cyberAttackManagementStatus.Done" class="status done">Done</span>
            <span *ngSwitchCase="cyberAttackManagementStatus.NeedAction" class="status need-action">Need
                action</span>
            <span *ngSwitchCase="cyberAttackManagementStatus.Pending" class="status pending">Pending</span>
        </div>
        <p>Type: {{attack.type}}</p>
        <div>
            <ng-content *ngIf="attack.type != cyberAttackTypeEnum.BehavioralAbnormality">
                <p>Source Addresses: {{attack.sourceAddresses}}</p>
                <p>Destination Address: {{attack.destinationAddress}}</p>
                <p>Connections: {{attack.connections}}</p>
                <p>Packets: {{attack.packets}}</p>
            </ng-content>
            <p *ngIf="usersWhoManagedAlert.get(attack.id)?.length != 0">Users: {{
                usersWhoManagedAlert.get(attack.id)?.join(', ') }}</p>
            <p *ngIf="attack.cyberAttackManagements.length != 0">Current manage: {{
                attack.cyberAttackManagements[0].type}}</p>
            <div class="d-flex flex-horizontal gap-2">
                <button class="button mini wide" [disabled]="disableManage(attack, cyberAttackManagementType.BlockIp)"
                    (click)="manage(attack, cyberAttackManagementType.BlockIp)">Block
                    IP</button>
                <button class="button mini wide" [disabled]="disableManage(attack, cyberAttackManagementType.Manual)"
                    (click)="manage(attack, cyberAttackManagementType.Manual)">Manual
                </button>
                <button class="button mini wide" [disabled]="disableManage(attack, cyberAttackManagementType.HoneyPot)"
                    (click)="manage(attack, cyberAttackManagementType.HoneyPot)">HoneyPot</button>
            </div>
            <div class="mt-2">
                <button class="button mini wide" [disabled]="attack.cyberAttackManagements.length == 0"
                    (click)="unmanage(attack)">Unmanage</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-bottom-bar">
    <button class="button outline mini wide" (click)="dialogRef.close()">Close</button>
</div>